export const LOGIN_PATH = "/login";
export const FORGOT_PASSWORD_PATH = "/forgot-password";
export const RESET_PATH = "/reset";
export const VERIFY_PATH = "/verify";

export const ADMIN_TASKS = ["users", "groups", "folders"];

const RESERVED_SEGMENTS = new Set([
  "login",
  "forgot-password",
  "reset",
  "verify",
  "admin",
  "d",
]);

export function isAuthPath(pathname) {
  return (
    pathname === LOGIN_PATH ||
    pathname === FORGOT_PASSWORD_PATH ||
    pathname === RESET_PATH ||
    pathname === VERIFY_PATH
  );
}

export function slugify(value) {
  return String(value || "")
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

export function workbookSlug(workbook) {
  const slug = slugify(workbook?.name);
  if (slug && !RESERVED_SEGMENTS.has(slug)) return slug;
  return workbook?.id || slug || "workbook";
}

export function viewSlug(view, index = 0) {
  return slugify(view?.label) || view?.id || String(index);
}

export function dashboardPath(workbook, view, index = 0) {
  const workbookKey = workbookSlug(workbook);
  if (!workbookKey) return "/";
  const encodedWorkbook = encodeURIComponent(workbookKey);
  const nextView = viewSlug(view, index);
  if (!nextView) return `/${encodedWorkbook}`;
  return `/${encodedWorkbook}/${encodeURIComponent(nextView)}`;
}

export function adminPath(task = "users") {
  const safeTask = ADMIN_TASKS.includes(task) ? task : "users";
  return `/admin/${safeTask}`;
}

export function viewKey(view, index) {
  return (view && view.id) || String(index);
}

export function matchesWorkbook(workbook, key) {
  if (!workbook || !key) return false;
  return workbook.id === key || workbookSlug(workbook) === key;
}

export function matchesView(view, index, key) {
  if (!key) return false;
  return viewKey(view, index) === key || viewSlug(view, index) === key;
}

export function parsePortalPath(pathname) {
  const clean = (pathname || "/").replace(/\/+$/, "") || "/";
  const adminMatch = clean.match(/^\/admin(?:\/(users|groups|folders))?$/);
  if (adminMatch) {
    return { kind: "admin", task: adminMatch[1] || "users" };
  }
  const legacyDash = clean.match(/^\/d\/([^/]+)(?:\/([^/]+))?$/);
  if (legacyDash) {
    return {
      kind: "dashboard",
      workbookKey: decodeURIComponent(legacyDash[1]),
      viewKey: legacyDash[2] ? decodeURIComponent(legacyDash[2]) : "",
    };
  }
  const slugDash = clean.match(/^\/([^/]+)(?:\/([^/]+))?$/);
  if (slugDash) {
    const workbookKey = decodeURIComponent(slugDash[1]);
    if (!RESERVED_SEGMENTS.has(workbookKey.toLowerCase())) {
      return {
        kind: "dashboard",
        workbookKey,
        viewKey: slugDash[2] ? decodeURIComponent(slugDash[2]) : "",
      };
    }
  }
  return { kind: "home", pathname: clean };
}

export function destinationFromLocation(location) {
  if (!location || isAuthPath(location.pathname)) {
    return "/";
  }
  return `${location.pathname}${location.search || ""}`;
}
